module.exports = __webpack_public_path__ + "static/masterOfHorror-3b02eb7856db61f3ac018ee64ab4b58d.jpg";